import Vue from "vue";
import VueRouter from "vue-router";
import LowerPageTemplate from "../views/LowerPageTemplate";
import IndexPage from "../views/IndexPage";
import CautionPage from "../views/CautionPage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: IndexPage,
    props: {
      title: "",
      writer: "",
      car: "",
      text: "",
    },
  },
  {
    path: "/caution/",
    name: "caution",
    component: CautionPage,
    props: {
      title: "",
      writer: "",
      car: "",
      text: "",
    },
  },
  {
    path: "/story001/",
    name: "story001",
    component: LowerPageTemplate,
    props: {
      title: "story001",
      writer: "2cvAZ from Coventry",
      car: "2CV",
      text:
        '高校生の時、初めてCXを見てシトロエンに興味を持ちましたが、その後、なんとなく購入したのが2cv。でも、今では2cvがとても気に入っています。一言で言えば、シンプルでタフ。<br>\
      広くはないが狭くはない、シンプルだけど不満はない、速くはないが遅くはない、必要最小限ではあるけれど、乗るとドライバーも同乗者も幸せな気分になれる（個人の感想です）、そんなところが無二の存在だと思っています。<br>\
      ーエピソードー<br>\
      1979年、高校生の時、近所の車屋にCXが停めてあったのがシトロエンに興味を持つきっかけでした。<br>\
      1983年、大学生の時、シトロエンを買おうと決めたのですが、CXは貧乏学生には高嶺の花、手が届く範囲では、GS(A)か2cvが現実的な選択肢でした。GS(A)はオーナーさんがとても苦労している、そんな時代でもあり、ほとんどトラブルの話題を聞いたことがなく、輸入が再開されたばかりの2cvを無理して新車購入することにしました。<br>\
      特に2cvが好きだった訳ではなく、古い時代に設計された新車に乗る最後のチャンスかな、程度の軽い気持ちでした。<br>\
      1983年に初めて2cvオーナーになりましたが、1987年、「2cvが生産中止になる」という噂が世界中を駆け回り、2CVGBというイギリスの2cvのクラブが中心になり、1台の2cvのボディパネルをバラバラにして世界中に送り、世界中の2cvオーナーが2cv生産中止反対の署名して返送。イギリスで再びボディパネルを組み付け、パリをデモしながら「世界中の2cvオーナーの生産中止反対署名入りボディの2cv」をシトロエン社に置いてくる、という "SAVE THE TORTOISE SAVE THE 2CV"というキャンペーンの日本の2cvオーナーの署名活動の取りまとめをしたのがきっかけで、イギリスの2cvオーナーさんとコンタクトを取るようになり、まだインターネットがない時代、現地のミーティングの様子を知るきっかけになりました。<br>\
      1992年初めてイギリスに行き、現地のシトロエンのミーティングに参加。翌年、イギリス人2cvオーナーさんから、古い2cvを買わないか、というお話を頂き、当時所有していた4台（ナンバー付き2台、可動1台、不動1台）の2cvを手放し、1993年に1955年型2cvを輸入しました。<br>\
      イギリスの2cvGBの友人にも協力してもらい、業者を通さず、まったくの個人輸入でその2cvは日本にやってきました。。通関は業者に依頼しましたが、輸入後、日本国内新規登録の書類作りや保安基準適合の改造等も業者を使わず個人で行い、新規登録をしました。<br>\
      以来、出来る範囲の整備やメンテナンスは自分でやるように心がけ（できない事も多々あります）26年、その前に2cvを所有していた期間の10年を入れると合計36年、気が付けば、人生の半分以上の時間をを2cvと共に過ごして来たことになりました。現在、その1955年式2cvと、2017年に購入したC4カクタスと共に、シトロエンライフをマイペースで楽しんでいます。以上。長文、大変失礼致しました。',
    },
  },
  {
    path: "/story002/",
    name: "story002",
    component: LowerPageTemplate,
    props: {
      title: "story002",
      writer: "Natsuo Tanabe",
      car: "C5",
      text:
        "初代C5です。<br>\
      2001年のデビュー時に当時東京にあった輸入車ショールームで見て「これは新鮮！」と思い、数日後には最寄りディーラーの方から直筆手紙とカタログが。直ぐにでも欲しかったので、その二週間後に訪れた東京モーターショーで説明員の方に話を伺おうとしたら、奇遇にもそのディーラー担当者ご本人で、これは縁だと即購入に踏み切りました。<br>\
      今でも大好きなグリライン色、大人5人が余裕で乗れる広さと充分なラゲッジルーム、何よりも優しい乗り心地と快適なシートで、12年間お世話になりました。<br>\
      運転の師匠であった今は亡き父親のラストドライブカー、生後間もない息子のファーストライドカー、色々な所に行った思い出は数知れず。<br>\
      たまにシトロエンの新型車を見に行くと機嫌が悪くなることもしばしば。<br>\
      初めはスムーズな運転に慣れるのに1ヶ月くらい掛かりましたが、結局C5の運転感覚から抜け出せなくなり、その後C5ツアラーに替わりました。<br>\
      他にも好きなシトロエン車は有りますが、また天国(？)から怒られると恐いので、我がlove No.1はグリラインのC5ということで！",
    },
  },
  {
    path: "/story003/",
    name: "story003",
    component: LowerPageTemplate,
    props: {
      title: "story003",
      writer: "zelly_ito",
      car: "XM",
      text:
        "95年に最初のXMを買って以来これまでに4台のXmを乗継ました。印象深い思い出。最初のXMで初の苗場。冬場は至極快適なスキーエクスプレスでした。帰りにガソリンを入れ一服してXMに戻ろうとした瞬間、目の前が真っ白に。給油機の上の屋根からXM目がけて雪の塊がドサっと落ちてきました。一瞬、目一杯車体が沈み込み、「ああ！潰れた」と思ったのですが、やがてムクムクと、「ああ、重かった」と言わんばかりにゆっくりと車高が回復。幸い軽い雪で屋根へのダメージもありませんでした。初めてハイドロニューマチックの動物的な(笑)一面を垣間見た瞬間でした。でもね、帰りは快適過ぎて地獄の睡魔との戦いが恐怖なXMでありました。",
    },
  },
  {
    path: "/story004/",
    name: "story004",
    component: LowerPageTemplate,
    props: {
      title: "story004",
      writer: "2cvalc2cv",
      car: "2CV",
      text:
        "幼少期、母に買ってもらったミニカーに始まり、それに乗るために免許をとった憧れのクルマ、それがシトロエン2CV。<br>\
      亡き祖母との思い出もありつつ、今の生活にいつも寄り添ってくれる存在。<br>\
      ただの移動手段ではない、生活を豊かにしてくれる「家族」です。",
    },
  },
  {
    path: "/story005/",
    name: "story005",
    component: LowerPageTemplate,
    props: {
      title: "story005",
      writer: "nakazigzag",
      car: "2CV",
      text:
        "〝親友の子供とパシャ〟<br>\
        小学校2年生からの親友。鉄道模型、熱帯魚、同じものにハマってました。やがて、大人になり、車を所有。親友も私もシトロエン。20代は互いに2CV、よくドライブ行ったね。後に親友はZX、私は原点回帰で再び2CV。親友の息子も2CVが大好き。段ボールで作った2CVを目を輝かせて見せてくれた。私たちの友情をより豊かに繫ぐものシトロエン。",
    },
  },
  {
    path: "/story006/",
    name: "story006",
    component: LowerPageTemplate,
    props: {
      title: "story006",
      writer: "kiitoslim",
      car: "ZX",
      text:
        "私のお気に入りシトロエンは、ZXブレークと現在の愛車であるC4です。<br>\
      初めてシトロエンに乗ったのは21年前のこと。先輩に借りたZXブレークでした。<br>\
      エッジの効いたデザイン、フカフカのシート、非力ながらも何処までも走りたくなる不思議な魅力を持ったクルマでした。<br>\
      あれからずいぶん時は経ちましたが未だにあの時の記憶が忘れられず、車種は違いますが私もシトロエン乗りになりました。<br>\
      C4はZXとは全く味付けが違いますが、シトロエンらしさはしっかりと受け継いでるような気がします。<br>\
      C4にはこれからも末長く乗り続けていきたいですね。",
    },
  },
  {
    path: "/story007/",
    name: "story007",
    component: LowerPageTemplate,
    props: {
      title: "story007",
      writer: "c3_matsu",
      car: "C3",
      text:
        "この車を知ったのは岡崎五郎さんのクルマで行こう！でした。祖父母に内緒でこっそり契約したらガチギレされ親戚まで巻き込む形に。今ではこのクルマ可愛いなぁと。82歳の祖父が言いながら乗ることもあります。イベントを通じて会えた方々には本当に感謝です！ ",
    },
  },
  {
    path: "/story008/",
    name: "story008",
    component: LowerPageTemplate,
    props: {
      title: "story008",
      writer: "c4life5",
      car: "タイプH",
      text:
        "子供がHトラックを好きすぎて、40年前のトミカを中古で発掘してきました。イベントの時なども、キッチンカー仕様のHトラックに釘付けです。ウチのクルマ、C4スペースツアラーなんだけどなぁ…。",
    },
  },
  {
    path: "/story009/",
    name: "story009",
    component: LowerPageTemplate,
    props: {
      title: "story009",
      writer: "Iam_marsseacher",
      car: "2CV",
      text:
        "大学2年の春に一目惚れし、ワンオーナー挟んだ後に手に入ったクルマです。カーライフのイロハを教えてくれるいい先輩カーです。",
    },
  },
  {
    path: "/story010/",
    name: "story010",
    component: LowerPageTemplate,
    props: {
      title: "story010",
      writer: "restivehorse2cv",
      car: "2CV",
      text:
        "2cvに魅せられて18年2cvの整備練習の為に納車したカブでフレンチブルーミーティングへ",
    },
  },
  {
    path: "/story011/",
    name: "story011",
    component: LowerPageTemplate,
    props: {
      title: "story011",
      writer: "sokazu",
      car: "C4",
      text:
        "その時乗ってるシトロエンが最上のシトロエン18歳で免許を取りユーノスで中古のAXを3台続けて買いZX・BX・Xanbrk2台・1stC5・C4・C4ディーゼルと（間に307と某眼鏡入ってますが）乗ってきてどれも良い車で思い出は沢山。念願のディーゼルで上がりのクルマでも良いかなと。",
    },
  },
  {
    path: "/story012/",
    name: "story012",
    component: LowerPageTemplate,
    props: {
      title: "story012",
      writer: "toybox3302",
      car: "BX",
      text:
        "自分にとってはやっぱりBX。力を抜いてどこまでも行ける、よき相棒です。子供の頃に我が家のファミリーカーだったので、旅行の思い出はほとんどBXと共にあります。最近父が乗っていたのと同じ年式・色のBXを手に入れましたが、右のシートは父の席なので、左ハンドルを選びました。",
    },
  },
  {
    path: "/story013/",
    name: "story013",
    component: LowerPageTemplate,
    props: {
      title: "story013",
      writer: "punto2cv",
      car: "2CV",
      text:
        "買って丸六年経った2CV合理的で必要最低限、なのにいくら乗っても飽きのこない不思議な車。シトロエンをAXBXシャンソンと乗り継いで2CVでアガリ車に辿り着いた感が。",
    },
  },
  {
    path: "/story014/",
    name: "story014",
    component: LowerPageTemplate,
    props: {
      title: "story014",
      writer: "Maria_Sakuraba",
      car: "DS3",
      text:
        "【CITROËN DS3】20歳で出会ったこのクルマに魅せられて、6MTの集大成であるPerformance LINE MT FINAL VERSIONを新車購入。デザイン良し、走り良しの満足の1台です。今後こういう楽しめるクルマが新しく出ないのが残念ですが、潰れるまで乗り続けます。",
    },
  },
  {
    path: "/story015/",
    name: "story015",
    component: LowerPageTemplate,
    props: {
      title: "story015",
      writer: "B_B_BX",
      car: "BX",
      text:
        "いちばん好きなのはBX。親父が乗ってた19TZiのブレークから数えるともう20年近く乗ってることになるけど、全く飽きが来ず、使いやすいサイズと広い室内のお陰で、普段使いに我慢しなくていいのが最高。",
    },
  },
  {
    path: "/story016/",
    name: "story016",
    component: LowerPageTemplate,
    props: {
      title: "story016",
      writer: "Satcatype",
      car: "C4",
      text:
        "小学生の時見ていたラリーの動画に出てきたのがC4 WRCフォーカスやインプレッサ、SX4等の中でもエクステリアが独特で好きだった上京して大学生になりC4 VTSを購入、実家の鹿児島まで1人で帰省しても全然疲れない快適性！マニュアルだからガチャガチャ操作するの楽しいです⚙",
    },
  },
  {
    path: "/story017/",
    name: "story017",
    component: LowerPageTemplate,
    props: {
      title: "story017",
      writer: "BonKazu",
      car: "DS4",
      text:
        "DS4に乗ってます。世界で一番美しい車です。リアウインドウがはめ殺しな所やリアのドアハンドルの位置も好きです。見た目だけじゃなく、運転しやすく長距離運転しても疲れ難いです。同じ車と余りすれ違わないとこも。",
    },
  },
  {
    path: "/story018/",
    name: "story018",
    component: LowerPageTemplate,
    props: {
      title: "story018",
      writer: "RY_42",
      car: "AX",
      text:
        "シトロエンAX 小さい頃、親父と二人で中古車屋に見に行って買った。助手席が指定席だったので、左ハンドルの恩恵で子供心には運転手気分にさせてくれたクルマだった。第10回目のフレンチブルーミーティングにも行って、フランス車好きになったキッカケを作ってくれた。",
    },
  },
  {
    path: "/story019/",
    name: "story019",
    component: LowerPageTemplate,
    props: {
      title: "story019",
      writer: "FFCitroen",
      car: "DS3",
      text:
        "親父がDS3に一目惚れ、長年の愛車との別れで最初はDS3を好きじゃなかったけど何度も乗せてもらってドライブするうちにすっかり魅了され、FBPで旧いシトロエンの素晴らしさを知り気付けば自分もシトロエンを乗るように。最高の車だと思います、DS3！",
    },
  },
  {
    path: "/story020/",
    name: "story020",
    component: LowerPageTemplate,
    props: {
      title: "story020",
      writer: "CFT15805339",
      car: "DS3",
      text:
        "あまり興味がなかった輸入車ショーでDS3を見つけて一目惚れ✨シートに座った瞬間のフィット感と内装にびびっときた！走らんくなるまで乗る！",
    },
  },
  {
    path: "/story021/",
    name: "story021",
    component: LowerPageTemplate,
    props: {
      title: "story021",
      writer: "touhokuB",
      car: "エグザンティア",
      text:
        "初デートで乗った、夫の運転するエグザンティアブレーク。下手なブレーキで停車した後は、いつもフロントが少し持ち上がって。地味だと思っていた外観、長年かけて愛着がわいた頃に…別れの時。風を受けていたエンブレムも、今は私と部屋の中。お願い、夢に出てきて欲しい。",
    },
  },
  {
    path: "/story022/",
    name: "story022",
    component: LowerPageTemplate,
    props: {
      title: "story022",
      writer: "dorachan_nobita",
      car: "C6",
      text:
        "小学生の頃、図書室にあったCGのC6発表記事で一目惚れ。その後10年越しに、憧れのクルマを購入しました。安楽な乗り心地唯一無二のエクステリアデザイン落ち着いたインテリアデザインとってもステキなクルマです🐳",
    },
  },
  {
    path: "/story023/",
    name: "story023",
    component: LowerPageTemplate,
    props: {
      title: "story023",
      writer: "attukun38",
      car: "Grand C4 Spacetourer",
      text:
        "シトロエン C3プルリエルあの愛くるしいデザインかつ、オープンカーで風を感じる事ができる車🚗今はシトロエンピカソ を愛車としていますがいつか2台目を所有したい車の一つです。",
    },
  },
  {
    path: "/story024/",
    name: "story024",
    component: LowerPageTemplate,
    props: {
      title: "story024",
      writer: "roukentop",
      car: "DS3",
      text:
        "うちの営業車❕後部座席は狭いけど、めっちゃ荷物載る❗大型クレートも余裕❗長距離全然疲れない～～<br>\
      もう8万キロ…まだまだ元気に頑張ってもらおう。",
    },
  },
  {
    path: "/story025/",
    name: "story025",
    component: LowerPageTemplate,
    props: {
      title: "story025",
      writer: "yg45yg",
      car: "Grand C4 Spacetourer",
      text:
        "C4 picasso コンセプトカー「テクノスペース」の姿に一目惚れ。正規導入が待ちきれず、結婚10周年記念にかこつけて英国仕様を並行輸入しました。 ディーゼル＋6ETGで高速道路走行なら 25km/l も余裕。家族をあちこち連れて行ってくれてます。",
    },
  },
  {
    path: "/story026/",
    name: "story026",
    component: LowerPageTemplate,
    props: {
      title: "story026",
      writer: "daisukeDK4",
      car: "XM",
      text:
        "小学生の時親父が中期Xmに乗っており、あのすぐ壊れる意味不明さに惚れ初期XMを買ってしまいました。中期Xmが1番すきです。今入院中で退院したら日常の足車に2CVを買おうと思いましたが、友達が口を揃えてダサいと言うのでDS5を買う予定です。",
    },
  },
  {
    path: "/story027/",
    name: "story027",
    component: LowerPageTemplate,
    props: {
      title: "story027",
      writer: "1_0_4_9_",
      car: "BX",
      text:
        "BXが好きです。昔イベントで運転席に座らせてもらった時からその未来的なデザインに虜でした。カクカクしたスタイリングに長時間運転しても快適なフカフカシートが魅力。 エンジンをかけると車高が上がるところとか時々不調になるところも生き物みたいで好きです！",
    },
  },
  {
    path: "/story028/",
    name: "story028",
    component: LowerPageTemplate,
    props: {
      title: "story028",
      writer: "tomoroen",
      car: "AX",
      text:
        "シトロエンAXは今年2台乗り続けて20年となりました。<br>\
      元気なエンジンと軽い車体でいつも楽しくそして優しい乗り心地…僕にとって最高の相棒ですね。",
    },
  },
  {
    path: "/story029/",
    name: "story029",
    component: LowerPageTemplate,
    props: {
      title: "story029",
      writer: "matsuwitter",
      car: "BX",
      text:
        "BXとXsara。21年間で所有したことのあるシトロエン。サイズもだいたい同じくらい。BXにもXsaraにもシトロエンというメイクスが考える人と社会と車に対する一貫したメッセージが詰まっているよね。深いです。エピソード…あり過ぎて。今7歳の子どももシトロエンが大好き。",
    },
  },
  {
    path: "/story030/",
    name: "story030",
    component: LowerPageTemplate,
    props: {
      title: "story030",
      writer: "2cvmou",
      car: "2CV",
      text:
        "2CVが好きです。<br>\
      クランクがけでエンジンがかかる車に憧れました。<br>\
      バッテリーが無くても走る車なんて現代では考えられません。<br>\
      実用性を突き詰めたコンセプトで生まれた車でデザインも最高です。",
    },
  },
  {
    path: "/story031/",
    name: "story031",
    component: LowerPageTemplate,
    props: {
      title: "story031",
      writer: "taktak_tama",
      car: "エグザンティア",
      text:
        "シトロエンXantia、最初の半年間、運転のリズムが前車のプジョー405と全く合わなくて苦労。その後、長距離ドライブで全然疲れていないことに気がついた。それからはシトロエン一筋20年。今は初代c5ブレーク。11年経ちますが全く飽きず。",
    },
  },
  {
    path: "/story032/",
    name: "story032",
    component: LowerPageTemplate,
    props: {
      title: "story032",
      writer: "bx16tzi1992",
      car: "BX",
      text:
        "シトロエンに乗りたくて買ったBX<br>\
      結婚を機にC3へ買い替え<br>\
      ハイドロにまた乗りたくて買ったエグザンティア<br>\
      一時的に夢のシトロエン2台体制<br>\
      買わないと後悔すると思ったカクタス。<br>\
      カクタスを見て義理の姉が買ったC3。<br>\
      うちはシトロエンが居ない生活は考えられない",
    },
  },
  {
    path: "/story033/",
    name: "story033",
    component: LowerPageTemplate,
    props: {
      title: "story033",
      writer: "cockatoo5",
      car: "C4ピカソ",
      text:
        "お気に入りのシトロエンモデル：グランドC4ピカソです。その理由：鯨のような個性的なデザインとエコランで30km/Lを記録出来る経済性、高速域とワインディングで光る動力性能。歴代の愛車では最も満足度が高いことです。エピソード：11/9に標高2,000mにある大鹿村の「天空の池」でマジックアワーを待ってピカソと池のリフレクションを撮った画像です。天空の池までの道のりはダート＋急な登り坂なので２WDで登るのは難しいと言われているところですが、ピカソは難なく登り切ってくれました。お陰で非日常的な景色をたくさん撮ることが出来ました。",
    },
  },
  {
    path: "/story034/",
    name: "story034",
    component: LowerPageTemplate,
    props: {
      title: "story034",
      writer: "seastar_gram",
      car: "C4カクタス",
      text:
        "C4カクタス。昨年の納車から1年半、他の手段では難しい様々な場所に連れて行ってくれました。まだまだ慣らしが終わったところ。未来的なフォルムがフューチャーレトロになるまで連れ添いたい相棒。クラシックシトロエン達が機械を越えた佇まいをみせる様に。",
    },
  },
  {
    path: "/story035/",
    name: "story035",
    component: LowerPageTemplate,
    props: {
      title: "story035",
      writer: "sakula1joji",
      car: "C4 Spacetourer",
      text:
        "私は「シトロエンC4グランドツアラー ブルーフォレ 100周年限定内装使用車」です。車内の開放感がすごくて、ビューパノラマ感が前後左右上まで、オープンカーのよう。後部席も全席のシートの作りを後部席のために考えたデザインになっていて足をおもいっきり伸ばしたり、足を組んでも前座席に当たらない。新色のブルーフォレ、光によって色が柔らかく変化するさまは、孔雀のよう。内装の低反発シートやマッサージ機能も長距離移動には素敵な機能ですね。専属の調香師が作ったmangoの香りも好きです。",
    },
  },
  {
    path: "/story036/",
    name: "story036",
    component: LowerPageTemplate,
    props: {
      title: "story036",
      writer: "keiji_keipica",
      car: "C4ピカソ",
      text:
        "やっぱりシトロエン車で一番のお気に入りは、C4ピカソですね～。 この解放感は他の車では味わえません‼️息子がシトロエンの車を認識したのもこの車です。まぁ～最初の頃はシトロエンのマークを見て、何でもピカソって言っていましたけど😅冬の豪雪で他の車が走れなくなっている時も普通に走っていけますし、頼もしい相棒です👌グラスルーフから見る空も素敵ですよ～👍 ",
    },
  },
  {
    path: "/story037/",
    name: "story037",
    component: LowerPageTemplate,
    props: {
      title: "story037",
      writer: "aoyane_ds3",
      car: "DS3",
      text:
        "シトロエン100年おめでとう👏私にとってお気に入りのシトロエンはやはり愛車のDS3ですね😉デザインに惚れ込んで買ったのもありますが乗っても楽しくまた、ネットを通して色々な方との繋がりが出来た、大袈裟かも知れませんが人生観が変わった車です。そして現在販売している多くの車にデザイン面で少なからず影響を与えた車だと思ってます。過去の名車達に捕らわれずに新しく進むことが出来た、シトロエン自身にとってもターニングポイントになった車なのではと思ってます😄",
    },
  },
  {
    path: "/story038/",
    name: "story038",
    component: LowerPageTemplate,
    props: {
      title: "story038",
      writer: "arisa.seira",
      car: "C3",
      text:
        "❤️C 3❤️ が大好きなモデル🚗😋✨ 🌻C3購入のエピソード🌻<br>\
      ８年前、母が早期退職するにあたり、<br>\
      父が母に<br>\
      『退職祝いプレゼント✨🎁✨』として、サプライズに送った車です😁💮❤️ これからもピカピカのC3で、<br>\
      仲良く通勤してね😌❤️",
    },
  },
  {
    path: "/story039/",
    name: "story039",
    component: LowerPageTemplate,
    props: {
      title: "story039",
      writer: "daisuite_from_tyo",
      car: "ZX",
      text:
        "軽快、スポーティ、お洒落、ハイドロじゃなくてもしっかりシトロエンの乗り味でどこまでも走れるパートナーでした。<br>\
        <br>\
        そしてそんなZXとの出会いから20年後、再びシトロエンが私のパートナーになりました。<br>\
        C4ピカソ、フランスを旅した時に一目惚れし、その素敵なスタイリングが忘れられないまま時を経たいま、ここ東京で共に暮らしています。",
    },
  },
  {
    path: "/story040/",
    name: "story040",
    component: LowerPageTemplate,
    props: {
      title: "story040",
      writer: "tsukamp",
      car: "AMI6",
      text:
        "やっとシトロエン一年生になれました…<br>\
        数年前2CVを探し始めてami6 に出会い、DSと2CVの中間という控えめさに衝撃を受け購入したのが1年前。これからゆっくり楽しんで行きたいですね。",
    },
  },
  {
    path: "/story041/",
    name: "story041",
    component: LowerPageTemplate,
    props: {
      title: "story041",
      writer: "makogg50",
      car: "C3",
      text:
        "お気に入りはやっぱりc3 。たまたま街で走ってるのを見かけてそのままディーラーさんへ(笑)<br>\
        きっかけは一目惚れですが、乗り味&木靴のようなウィンカーのコツコツ音、全てお気に入りです💗",
    },
  },
  {
    path: "/story042/",
    name: "story042",
    component: LowerPageTemplate,
    props: {
      title: "story042",
      writer: "1974_cx_japon",
      car: "CX",
      text:
        "1974年のcitroen cx 2000<br>\
        どうしても欲しかった、最初期のcx。現存するcxで5番目に古い個体。オランダのコレクター、Ward Hagenaar さんから譲り受けました。あとはナンバー取得するのみ。",
    },
  },
  {
    path: "/story043/",
    name: "story043",
    component: LowerPageTemplate,
    props: {
      title: "story043",
      writer: "kame2cv",
      car: "2CV",
      text:
        "お盆もお彼岸も墓参りに行けなかったから、祖父の命日に。<br>\
        家族に会える貴重な場。<br>\
        我が相棒シトロエン2CVとともに。",
    },
  },
  {
    path: "/story044/",
    name: "story044",
    component: LowerPageTemplate,
    props: {
      title: "story044",
      writer: "tetsuchangue",
      car: "2CV",
      text:
        "マイベストシトロエンは7年一緒にいた初代C4(の前期型)ですね。全然名車の系譜じゃないけど。椅子代が値段の8割の様な乗り心地と適度に奇天烈なスイッチ類と、シトロエンの乗り方を知らないと酷い運転になるお作法と、下り坂だったら大抵の車が来ても負けない運動性と、どこへも一緒に行く良き相棒でした。ミシュランのエナジーセーバーもグリップの際がきっちり分かる良いタイヤでした。<br>\
        My best Citroen is The C4 of 1st generation.",
    },
  },
  {
    path: "/story045/",
    name: "story045",
    component: LowerPageTemplate,
    props: {
      title: "story045",
      writer: "辻本 真幸",
      car: "C5ツアラー",
      text:
        "今、愛車とさせて頂いているC5ツアラーです。<br>\
        もちろん、過去にも素晴らしい出会いがありましたが、日々お世話になっている相方を差し置いて申し上げることはありません。<br>\
        先週も(自宅のある)鎌倉から、京都までの往復をなんの苦痛もなく、ただただ楽しい時間にさせてくれた今の相方が大好きです",
    },
  },
  {
    path: "/story046/",
    name: "story046",
    component: LowerPageTemplate,
    props: {
      title: "story046",
      writer: "Zenji Nagano",
      car: "CX",
      text:
        "AX、BXと乗り継ぎ、現在1987年式シトロエンCX25GTIに乗っており、今のCXに惚れ込んでいます。<br>\
        理由を列挙しますと、<br>\
        ①空力を意識した流麗なスタイリング<br>\
        ②ハイドロニューマチックによる「魔法の絨毯」の乗り心地<br>\
        ③体を優しく包み込む快適なシート<br>\
        ④セルフセンタリングによる驚異的な直進安定性<br>\
        ⑤いざという時に姿勢を崩すことなく超強力に効くブレーキ<br>\
        ⑥ステアリングから手を離さずに操作できる、よく考えられたスイッチ類<br>\
        ⑦全方位見やすい、広いガラスエリア<br>\
        ⑧以外と荷物が積めるトランク<br>\
        などなど…挙げればキリがありません。<br>\
        旧い車ですが、未だに乗ると新たな発見があったりして、その度にCXの、引いてはシトロエン車の素晴らしさを実感しています。",
    },
  },
  {
    path: "/story047/",
    name: "story047",
    component: LowerPageTemplate,
    props: {
      title: "story047",
      writer: "矢澤 暢子",
      car: "2CV",
      text:
        "クサラブレークです。シュッとしたノーズに細いグリル。小さいダブルシェブロン。加齢と共に乗り降りが辛くなる低い車体。エピソードは修理の歴史。書き始めたらエンドレスになりそうなほど。レッカー出動も数回。WRCの勇姿に魅せられた日から20年？　狭い道でのすれ違い時に、にゅっと手を出してミラーをたたむとき、駐車場でばこっとたたむとき、ギョッとされるのにも慣れました。ショックアブソーバーがアブソーブしていないライブ感がありますが、愛着には勝てません。",
    },
  },
  {
    path: "/story048/",
    name: "story048",
    component: LowerPageTemplate,
    props: {
      title: "story048",
      writer: "植田聡",
      car: "Grand C4 Spacetourer",
      text:
        "ずっとルノーに乗ってました<br>\
        ちょっと冷やかしでシトロエンに行って、c4グランドピカソに試乗したら、それが良くって買ったのが去年の5月<br>\
        そのクルマはまだ1年半なのに40000キロ超えました(笑)<br>\
        あんまりよかったので今月DS3も買いました<br>\
        結局、ルノーのメガーヌグラスルーフカブリオレとカングーを手放し、c4グランドピカソとDS3が我が家のガレージにあります！",
    },
  },
  {
    path: "/story049/",
    name: "story049",
    component: LowerPageTemplate,
    props: {
      title: "story049",
      writer: "hiroakimayuzumi",
      car: "2CV",
      text:
        "2cv<br>\
        今となっては不思議な自動車と見られるかもしれませんが、いい意味でドライバーの意図を素直に受け入れてくれるごく普通の自動車だと思っています。愉しい自動車です。ずっと乗るだろうなあ。",
    },
  },
  {
    path: "/story050/",
    name: "story050",
    component: LowerPageTemplate,
    props: {
      title: "story050",
      writer: "西村 俊一",
      car: "C4カクタス",
      text:
        "C4カクタスです。欲しくて欲しくて、初回入荷の抽選にあたり、白を購入することができました。もちろん納車前にオーダーして前後のガードとミラーカバーの純正オプションパーツも付けてもらいました。",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
